import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { TermsOfUse } from '../../features/policies/components/terms-of-use/terms-of-use';
import { RefundPolicy } from '../../features/policies/components/refund-policy/refund-policy';
import { PrivacyPolicy } from '../../features/policies/components/privacy-policy/privacy-policy';
import { HalfPricePolicy } from '../../features/policies/components/half-price-policy/half-price-policy';
import { Navbar } from '../../shared/components/navbar/navbar';
import { Footer } from '../../shared/components/footer/footer';

const POLICY_COMPONENTS: Record<string, React.ComponentType> = {
  'terms-of-use': TermsOfUse,
  'refund-policy': RefundPolicy,
  'privacy-policy': PrivacyPolicy,
  'half-price-policy': HalfPricePolicy,
};

export const Policies: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();

  if (!slug || !POLICY_COMPONENTS[slug]) {
    return <Navigate to="/" replace />;
  }

  const PolicyComponent = POLICY_COMPONENTS[slug];

  return (
    <>
      <Navbar />
      <PolicyComponent />
      <Footer />
    </>
  );
};

export default Policies;
